/**
 * @file tokenStorage.ts
 * @brief Thin wrapper around `localStorage` for the JWT auth token.
 *
 * @details
 * - Centralizes the storage key so we don't have magic strings scattered.
 * - Wraps every access in try/catch — Safari Private Mode and quota errors
 *   would otherwise crash the app.
 * - Phase 2 candidate: migrate to httpOnly cookie-based tokens for stronger
 *   XSS protection. Until then, localStorage is the pragmatic choice that
 *   matches the mobile app's behavior (AsyncStorage).
 *
 * @references
 * - WEBPANEL/src/shared/api/client.ts  (consumer — Axios interceptor)
 * - WEBPANEL/src/shared/auth/AuthContext.tsx (consumer — bootstrap)
 *
 * @author DES
 * @date 26-05-2026
 */

const TOKEN_KEY = "verblizr.webpanel.auth.token";

export const tokenStorage = {
  get(): string | null {
    try {
      return window.localStorage.getItem(TOKEN_KEY);
    } catch {
      return null;
    }
  },
  set(token: string): void {
    try {
      window.localStorage.setItem(TOKEN_KEY, token);
    } catch {
      // ignore
    }
  },
  clear(): void {
    try {
      window.localStorage.removeItem(TOKEN_KEY);
    } catch {
      // ignore
    }
  },
};
